/* eslint-disable react/prop-types */
import { React, useState } from 'react';

import { ContainerModal, TextModal } from './style.js';

import ButtonDefault from '../../ButtonDefault/index.js';

import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';

const ModalDelete = ({
  modalOpen,
  modalTitleText,
  modalText,
  handleClose,
  handleCancel,
  handleConfirm,
  id
}) => {
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'auto',
    bgcolor: 'rgb(241, 241, 241)',
    border: 'none',
    boxShadow: 24,
    p: 4,
    borderRadius: '10px',
    padding: '20px'
  };

  const styleInputs = {
    margin: '10px'
  };

  return (
    <>
      <Modal
        open={modalOpen}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={style}>
          <ContainerModal>
            <div>
              <h3 style={{ textAlign: 'center' }}>{modalTitleText}</h3>
              {modalText !== '' && (
                <p style={{ marginLeft: '20px', marginTop: '20px' }}>{modalText}</p>
              )}
              <div style={{ marginTop: '20px' }}>
                <ButtonDefault
                  Margin={styleInputs.margin}
                  Width={'200px'}
                  Text="Confirmar"
                  onClick={() => handleConfirm(id)}
                />
                <ButtonDefault
                  Margin={styleInputs.margin}
                  Width={'200px'}
                  style={{ float: 'right' }}
                  Text="Cancelar"
                  onClick={handleCancel}
                />
              </div>
            </div>
          </ContainerModal>
        </Box>
      </Modal>
    </>
  );
};

export default ModalDelete;
